import regionService from '@/api/region'
import { REGION_SET } from '../types'

export default {
  namespaced: true,
  state: {
    regions: []
  },
  getters: {
  },
  mutations: {
    [REGION_SET](state, regions) {
      state.regions = regions
    }
  },
  actions: {
    getRegionsList: function ({commit, dispatch}) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        regionService.getRegions().then((response) => {
          dispatch('Global/hideLoading', null, {root: true})
          commit(REGION_SET, response.data)
          resolve()
        }).catch((error) => {
          dispatch('Global/hideLoading', null, {root: true})
          reject(error)
        })
      })
    },
    getRegionDesks: function ({dispatch}, params) {
      let fixedAsset = params ? params.fixedAsset : undefined
      let inactivateLoading = params ? params.inactivateLoading : false
      if (!inactivateLoading) {
        dispatch('Global/showLoading', null, {root: true})
      }
      return new Promise((resolve, reject) => {
        regionService.getRegionDesks(fixedAsset).then((response) => {
          dispatch('Global/hideLoading', null, {root: true})
          resolve(response.data)
        }).catch((error) => {
          dispatch('Global/hideLoading', null, {root: true})
          reject(error)
        })
      })
    },

    getRegion: function ({dispatch}, id) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        regionService.getRegion(id).then((response) => {
          dispatch('Global/hideLoading', null, {root: true})
          resolve(response.data)
        }).catch((error) => {
          dispatch('Global/hideLoading', null, {root: true})
          reject(error)
        })
      })
    },
    addRegion: function ({dispatch}, region) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        regionService.addRegion(region).then(() => {
          dispatch('getRegionsList').then(() => {
            dispatch('Global/hideLoading', null, {root: true})
            resolve()
          }).catch((error) => {
            dispatch('Global/hideLoading', null, {root: true})
            reject(error)
          })
        }).catch((error) => {
          dispatch('Global/hideLoading', null, {root: true})
          reject(error)
        })
      })
    },
    editRegion: function ({dispatch}, region) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        regionService.editRegion(region).then(() => {
          dispatch('getRegionsList').then(() => {
            dispatch('Global/hideLoading', null, {root: true})
            resolve()
          }).catch((error) => {
            dispatch('Global/hideLoading', null, {root: true})
            reject(error)
          })
        }).catch((error) => {
          dispatch('Global/hideLoading', null, {root: true})
          reject(error)
        })
      })
    },
    deleteRegion: function ({dispatch}, id) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        regionService.deleteRegion(id).then(() => {
          dispatch('getRegionsList').then(() => {
            dispatch('Global/hideLoading', null, {root: true})
            resolve()
          }).catch((error) => {
            dispatch('Global/hideLoading', null, {root: true })
            reject(error)
          })
        })
      })
    }
  }
}
